var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_doc") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_doc",
    transform: "translate(-1431 -13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3697",
    "data-name": "Rectangle 3697",
    width: 24,
    height: 24,
    transform: "translate(1431 13)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "doc",
    d: "M3371.8,7162H3359v-16h8.229v4.7h4.571V7162Zm-2.958-6.747a1.468,1.468,0,0,0-.791.214,1.378,1.378,0,0,0-.525.605,2.147,2.147,0,0,0-.183.91v.341a2.155,2.155,0,0,0,.187.884,1.348,1.348,0,0,0,.514.588,1.42,1.42,0,0,0,.768.207,1.456,1.456,0,0,0,1-.327,1.316,1.316,0,0,0,.43-.909h-.631a.876.876,0,0,1-.239.559.821.821,0,0,1-.561.167.7.7,0,0,1-.62-.311,1.6,1.6,0,0,1-.212-.9v-.323a1.521,1.521,0,0,1,.227-.886.738.738,0,0,1,.636-.3.755.755,0,0,1,.539.174.9.9,0,0,1,.23.568h.631a1.374,1.374,0,0,0-.428-.928A1.415,1.415,0,0,0,3368.841,7155.252Zm-3.53,0a1.456,1.456,0,0,0-.791.217,1.416,1.416,0,0,0-.534.625,2.23,2.23,0,0,0-.189.942v.205a2.135,2.135,0,0,0,.192.925,1.414,1.414,0,0,0,.536.619,1.563,1.563,0,0,0,1.583,0,1.409,1.409,0,0,0,.53-.622,2.246,2.246,0,0,0,.187-.942v-.2a2.261,2.261,0,0,0-.191-.937,1.423,1.423,0,0,0-.534-.616A1.478,1.478,0,0,0,3365.311,7155.252Zm-4.752.05v3.648h1.05a1.782,1.782,0,0,0,.877-.212,1.459,1.459,0,0,0,.59-.606,1.973,1.973,0,0,0,.207-.913v-.183a1.937,1.937,0,0,0-.207-.908,1.478,1.478,0,0,0-.581-.611,1.7,1.7,0,0,0-.857-.215Zm4.758,3.178a.76.76,0,0,1-.651-.327,1.6,1.6,0,0,1-.234-.931v-.21a1.58,1.58,0,0,1,.236-.911.81.81,0,0,1,1.294,0,1.6,1.6,0,0,1,.23.929v.19a1.628,1.628,0,0,1-.227.938A.753.753,0,0,1,3365.316,7158.48Zm-3.71-.034h-.414v-2.631h.444a.921.921,0,0,1,.75.313,1.408,1.408,0,0,1,.257.908v.2a1.357,1.357,0,0,1-.271.9A.955.955,0,0,1,3361.606,7158.446Zm10.058-8.682h-3.521v-3.625l3.52,3.624Z",
    transform: "translate(-1922.4 -7129.002)",
    fill: "#3849a5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDoc);
export default __webpack_public_path__ + "static/media/ic_doc.57d06e7c1e7eccac32c538f5b4e12b55.svg";
export { ForwardRef as ReactComponent };